/*eslint-disable*/
import React from "react";
import { useState, useEffect} from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons

// core components

import { Radio, Space, Table, Tag, Divider } from 'antd';

import { styled } from '@mui/material/styles';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Swal from 'sweetalert2';

import FormControl from '@mui/material/FormControl';

import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';


import './styles.css';



const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0",
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF",
    },
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1",
    },
  },
};



const NotifSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 50,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(24px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#65C466',
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color:
        theme.palette.mode === 'light'
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));

import { useSelector } from 'react-redux';
//import { dataActions } from '../../store/data-slice';

export default function NotificationsConfig(props) {
  
  const { language } = useSelector( state => state.data);

  const translations = {
    en: {
      labelHum: "Soil Moisture",
      labelTemp: "Soil Temperature",
      labelBat: "Battery Load",
      labelPh: "PH",
      labelEc: "Electric Cond.",
      labelK: "Potasium (K)",
      labelP: "Phosphorus (P)",
      labelN: "Nitrogen (N)",
      labelDefault: "Soil Moisture",
      formLabel1: "Check every:",
      item15m: "15 minutes",
      item30m: "30 minutes",
      item1h: "1 hour",
      item6h: "6 hours",
      item12h: "12 hours",
      item1d: "1 day",
      item5d: "5 days",
      filtersTitle: "Notify when metric",
      filtersTitle2: "to",
      greater: "is great than:",
      lesser: "is less than:",
      range: "is out of range between:",
      
      
    },
    es: {
      labelHum: "Humedad del suelo",
      labelTemp: "Temperatura del suelo",
      labelBat: "Nivel de Batería",
      labelPh: "PH",
      labelEc: "Conductividad Eléctrica",
      labelK: "Potasio (K)",
      labelP: "Fósforo (P)",
      labelN: "Nitrógeno (N)",
      labelDefault: "Humedad del suelo",
      formLabel1: "Revisar cada:",
      item15m: "15 minutos",
      item30m: "30 minutos",
      item1h: "1 hora",
      item6h: "6 horas",
      item12h: "12 horas",
      item1d: "1 dia",
      item5d: "5 dias",
      filtersTitle: "Notificar cuando la métrica",
      filtersTitle2: "hasta",
      greater: "sea mayor a:",
      lesser: "sea menor a:",
      range: "esté fuera del rango entre:",
    }
  };

  // Get the current translation based on language
  const t = translations[language];
  
  
  
  const { type, name, factor, status, every, check_id, threshold_type, threshold_value, threshold_min, threshold_max} = props;
  
  
  const [loading, setLoading] = useState(false);
  
  const [values, setValues] = useState({
    status: "active", every: '15m', threshold_type: 'lesser', threshold_value: '10', threshold_min: '', threshold_max:'',    
  });
    
  let label="";
  let label_units="";

  switch (type) {
    case 'humedad':
      label = t.labelHum;
      label_units="%";
      break;
    case 'temperatura':
      label = t.labelTemp;
      label_units="°C";
      break;
    case 'bateria':
      label = t.labelBat;
      label_units="V";
      break;
    case 'ph':
      label = t.labelPh;
      label_units="ph";
      break;
    case 'ec':
      label = t.labelEc;
      label_units="mS/m";
      break;
    case 'potasio':
      label = t.labelK;
      label_units="mg/kg";
      break;
    case 'fosforo':
      label = t.labelP;
      label_units="mg/kg";
      break;
    case 'nitrogeno':
      label = t.labelN;
      label_units="mg/kg";
      break;
    default:
      label = t.labelDefault;
      label_units="%";
  }




  const handleChange = (prop) => (event) => {
    if (prop == "status"){
      if (event.target.checked){
        setValues({ ...values, [prop]: "active"});
        console.log("selected prop:", prop, " value: ", event.target.checked );
      }else{
        setValues({ ...values, [prop]: "inactive"});
        console.log("selected prop:", prop, " value: ", event.target.checked );
      }
      
      return;
    }
    
    setValues({ ...values, [prop]: event.target.value });
    console.log("selected prop:", prop, " value: ", event.target.value );
    console.log("values:", values);

  };

  
  
   

  useEffect(() => {
    
    setValues({type, name, factor, status, every, check_id, threshold_type, threshold_value, threshold_min, threshold_max});
    setLoading(false); 
        
  }, [])


  
  return (
    <>
      <div key={type} style={{display:'flex',padding:'15px', marginTop:'1px', marginLeft:'10px'}}>
          <FormGroup >
            <FormControlLabel
                control={<NotifSwitch sx={{ m: 1 }} defaultChecked />}
                label={label}
                labelPlacement="start"
                style={{color:'black'}}
                onChange={handleChange('status')}
              />
          </FormGroup>
    
          <div style={{display: "flex", flexDirection: 'row',  justifyContent: 'flex-start', alignItems: 'center', padding: '1px', marginLeft: '10px', marginBottom: '1px', flexWrap:'wrap'}}>
            <div className="filtersTitle"> {t.formLabel1} </div>
                <FormControl variant="standard" sx={{ m: 1, minWidth: 100 }} size="small">
                  <Select
                    value={values.every}
                    onChange={handleChange('every')}
                    disabled={ values.status=='inactive'?true:false}
                    //displayEmpty
                  >
                    <MenuItem value={'15m'}>{t.item15m}</MenuItem>
                    <MenuItem value={'30m'}>{t.item30m}</MenuItem>
                    <MenuItem value={'1h'}>{t.item1h}</MenuItem>
                    <MenuItem value={'6h'}>{t.item6h}</MenuItem>
                    <MenuItem value={'12h'}>{t.item12h}</MenuItem>
                    <MenuItem value={'1d'}>{t.item1d}</MenuItem>
                    <MenuItem value={'5d'}>{t.item5d}</MenuItem>
                  </Select>
                  
                </FormControl>
              
          
          </div>

          <div style={{display: "flex", flexDirection: 'row',  justifyContent: 'flex-start', alignItems: 'center', padding: '1px', marginLeft: '10px', marginBottom: '1px', flexWrap:'wrap'}}>
            <div className="filtersTitle"> {t.filtersTitle} </div>
                
                  
            <FormControl variant="standard" sx={{ m: 1, minWidth: 100 }} size="small">
              <Select
                value={values.threshold_type}
                onChange={handleChange('threshold_type')}
                disabled={ values.status=='inactive'?true:false}
                //displayEmpty
              >
                <MenuItem value={'greater'}>{t.greater}</MenuItem>
                <MenuItem value={'lesser'}>{t.lesser}</MenuItem>
                <MenuItem value={'range'}>{t.range}</MenuItem>
              </Select>

              

            </FormControl>
            
           
              {(()=>{  
                
                
                let rows2 = [];
                if (values.threshold_type === 'range') {
                    //console.log("entered between:");
                    rows2 = [];
                    rows2.push(
                          <div key={type} style={{display: "flex", flexDirection: 'row',  justifyContent: 'flex-start', alignItems: 'center', padding: '1px', marginLeft: '10px', marginBottom: '1px', flexWrap:'wrap'}}>
                             
                             <FormControl variant="standard" sx={{ m: 1, minWidth: 50 }} size="small" >
                               <Input
                                  id="min"
                                  value={parseInt(values.threshold_min/factor)}
                                  onChange={handleChange('threshold_min')}
                                  endAdornment={<InputAdornment position="end">{label_units}</InputAdornment>}
                                  aria-describedby="temp-helper-text"
                                  inputProps={{
                                    'aria-label': 'temp',
                                  }}
                                  size="small"
                                  style={{width:'50px'}}
                                  disabled={ values.status=='inactive'?true:false}
                               />
                            </FormControl>

                            <div className="filtersTitle"> {t.filtersTitle2} </div>

                            <FormControl variant="standard" sx={{ m: 1, minWidth: 50 }} size="small">
                                  <Input
                                    key="max"
                                    id="max"
                                    value={parseInt(values.threshold_max/factor)}
                                    onChange={handleChange('threshold_max')}
                                    endAdornment={<InputAdornment position="end">{label_units}</InputAdornment>}
                                    aria-describedby="temp2-helper-text"
                                    inputProps={{
                                      'aria-label': 'temp2',
                                    }}
                                    size="small"
                                    style={{width:'50px'}}
                                    disabled={ values.status=='inactive'?true:false}
                                  />
                            </FormControl>
                          </div>
                    );
                                
                }else{
                  rows2 = [];
                  rows2.push(
                        <div key={type} style={{display: "flex", flexDirection: 'row',  justifyContent: 'flex-start', alignItems: 'center', padding: '1px', marginLeft: '10px', marginBottom: '1px', flexWrap:'wrap'}}>
                           
                           <FormControl variant="standard" sx={{ m: 1, minWidth: 50 }} size="small" >
                             <Input
                                id="value"
                                value={parseInt(values.threshold_value/factor)}
                                onChange={handleChange('threshold_value')}
                                endAdornment={<InputAdornment position="end">{label_units}</InputAdornment>}
                                aria-describedby="temp-helper-text"
                                inputProps={{
                                  'aria-label': 'temp',
                                }}
                                size="small"
                                style={{width:'50px'}}
                                disabled={ values.status=='inactive'?true:false}
                             />
                          </FormControl>

                        </div>
                  );

                }


                return rows2;
              })()}


          </div>
          
      </div>  


    </>
      
  );
}
